import { render, staticRenderFns } from "./PlotLegendItemExpanded.vue?vue&type=template&id=082968e7&"
import script from "./PlotLegendItemExpanded.vue?vue&type=script&lang=js&"
export * from "./PlotLegendItemExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports